import * as React from "react";
import { useSelector } from "react-redux";

import { makeStyles, useMediaQuery } from "@material-ui/core";
import CategoryIcon from "@material-ui/icons/Category";
import classnames from "classnames";

import { DashboardMenuItem, MenuItemLink } from "react-admin";

import {
  AnnouncementsIcon,
  CustomersIcon,
  HelpIcon,
  LogoutIcon,
  LogsIcon,
  YardSetupIcon,
} from "../../components/common/iconography";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(2),
  },
  open: {
    width: 210,
  },
  closed: {
    width: 55,
  },
}));

const AdminMenu = ({ onMenuClick, dense }) => {
  const classes = useStyles();
  const xsDown = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const open = useSelector((state) => state.admin.ui.sidebarOpen);
  useSelector((state) => state.theme);

  return (
    <div
      className={classnames(classes.root, {
        [classes.open]: open,
        [classes.closed]: !open,
      })}
    >
      {" "}
      <DashboardMenuItem onClick={onMenuClick} sidebarIsOpen={open} />
      <MenuItemLink
        to={`/setupDatas`}
        primaryText="Registrations"
        leftIcon={<YardSetupIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      <MenuItemLink
        to={`/reloadYards`}
        primaryText="Reload Yards"
        leftIcon={<CustomersIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      <MenuItemLink
        to={`/announcements`}
        primaryText="Announcements"
        leftIcon={<AnnouncementsIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      <MenuItemLink
        to={`/commoditys`}
        primaryText="Load Types"
        leftIcon={<CategoryIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      <MenuItemLink
        to={`/helpPages`}
        primaryText="Help Pages"
        leftIcon={<HelpIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      <MenuItemLink
        to={`/logs`}
        primaryText="Logs"
        leftIcon={<LogsIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      {xsDown && (
        <MenuItemLink
          to="/logout"
          primaryText="Logout"
          leftIcon={<LogoutIcon />}
        />
      )}
    </div>
  );
};

export default AdminMenu;
